// extracted by mini-css-extract-plugin
module.exports = {"channel":"_3A-qi","channelImage":"_3NYPo","channelTitle":"_1UJWD"};